import ClockIcon from "@uui/ClockFastForward";
import { DateTime } from "luxon";
import { useLocation } from "react-router-dom";

import styled from "@mui/material/styles/styled";

import { isFreePlan } from "@app/analytics/account/Billing/utils";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import { withQueryParams } from "@app/common/utils";

import AlertBanner from "@rui/AlertBanner";
import Button from "@rui/Button";
import { Link } from "@rui/Link";
import { Bold } from "@rui/styles";

const Action = styled(Button)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  height: "fit-content",
  marginRight: theme.spacing(1),
  fontWeight: 600,
}));

const ReportExpirationBanner = ({
  expirationDate,
  show,
}: {
  expirationDate?: DateTime;
  show: boolean;
}) => {
  const location = useLocation();
  const { currentPlan } = useBillingContext();

  if (!show || !expirationDate || !isFreePlan(currentPlan.type)) {
    return null;
  }

  const numDaysRemaining = expirationDate.diffNow().as("days");

  if (numDaysRemaining < 0) return null;

  const severity = numDaysRemaining > 7 ? "info" : "warning";

  const formattedExpirationDate = expirationDate.toLocaleString({
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <AlertBanner
      severity={severity}
      icon={<ClockIcon />}
      action={
        <Link
          to={withQueryParams(
            location.pathname,
            { popup: "upgrade" },
            location.search
          )}
        >
          <Action variant="text">Upgrade</Action>
        </Link>
      }
      sx={{ pr: 2 }}
    >
      {currentPlan.label ? (
        <Bold>{currentPlan.label} quota exceeded:</Bold>
      ) : (
        <Bold>Quota exceeded:</Bold>
      )}{" "}
      Upgrade for unlimited. Report cannot be generated after 30 days (
      {formattedExpirationDate}).
    </AlertBanner>
  );
};

export default ReportExpirationBanner;
